// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9562 ? "3975359d" : chunkId) + "." + {"1369":"8c7d53f9b1d096ea","9562":"92097ed213e1ccb6"}[chunkId] + ".js";
};